module.exports = __webpack_public_path__ + "img/shopbuttonicon.15af7f18.svg";